import React, { useContext, useState } from 'react'
import { toast } from 'react-toastify'
import { BASE_URL_API } from '../../References/urls'
import AuthContext from '../../store/auth-context'
import styles from './UnHireCandidate.module.css'

const UnHireCandidate = (props) => {
    const { onClose, applicationIdentifier, getApplicationStatus } = props
    const [comment, setComment] = useState('')
    const authCtx = useContext(AuthContext)
    const [isUpdating, setIsUpdating] = useState(false)
    const [leavingDate, setLeavingDate] = useState('')

    const unHireCandidate = async () => {
        if (window.confirm("Are you sure you want to unhire this candidates?")) {
            if (comment !== '') {
                if(leavingDate!== '') {
                    setIsUpdating(true)
                    const response = await fetch(BASE_URL_API + "/updateApplicationStatus",
                        {
                            method: "POST",
                            body: JSON.stringify({
                                token: authCtx?.token,
                                actionRemarks: comment,
                                actionFor: 'UNHIRE',
                                applicationId: applicationIdentifier,
                                actionBy: authCtx?.userIdentifier,
                                leavingDate : leavingDate
                            })
                        })
    
                    if (!response.ok) {
                        console.log("Something went wrong : Server Error")
                    } else {
                        const respo = await response.json()
                        if (respo?.status === "success") {
                            toast('Candidate un-hired successfully!')
                            getApplicationStatus()
                            onClose()
                        } else {
                            if (respo?.message === "token Expired, please login again!") {
                                authCtx.logout()
                            }
                        }
                        console.log(respo)
                    }
                    setIsUpdating(false)
                } else {
                    alert("Please enter leaving date!")
                }
            } else {
                alert("Please enter the comments.")
            }
        }
    }


    return (
        <div className={styles.mainWrapper} >
            <div className={styles.mainContainer} >
                <div className={styles.mainContent} >
                    <div className={styles.contentWrapper} >
                        <div className={styles.inputTxt} >
                            <div className={styles.leavingWrapper} >
                                <span>
                                    Date of Leaving Job
                                </span>
                                <input type="date" value={leavingDate} onChange={(e) => setLeavingDate(e.target.value)} />
                            </div>
                            <textarea
                                className={styles.commentWrapper}
                                placeholder="Please mention the reason of leaving / un-hiring, keep as descriptive as possible..."
                                value={comment}
                                onChange={(e) => setComment(e.target.value)}
                                autoFocus
                            >

                            </textarea>
                        </div>
                        <div className={styles.footerWrapper} >
                            <div>
                                <button onClick={() => onClose()} className={styles.cancelBtn} >Cancel</button>
                            </div>
                            <div>
                                {isUpdating === false ?
                                    <button onClick={() => unHireCandidate()} className={styles.unhireBtn} >Un-hired</button>
                                    :
                                    <button className={styles.unhireBtn} >Please wait...</button>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default UnHireCandidate